<style scoped>
.loading-medium {
	font-size: 2.5rem;
}
.loading-large {
	font-size: 4rem;
}
.loading-page {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 10rem;
	opacity: 0.1;
}
.loading-icon {
	display: inline-block;
	width: 0.9em;
	height: 0.9em;
	border: 0.15em solid;
	border-right-color: rgba(70, 90, 110, 0.85);
	border-top-color: rgba(70, 90, 110, 0.85);
	border-left-color: rgba(70, 90, 110, 0.15);
	border-bottom-color: rgba(70, 90, 110, 0.15);
	border-radius: 100%;
	animation: spin 2s infinite linear;
}
.overlay {
	opacity: 1 !important;
	background-color: rgba(255, 255, 255, 0.5);
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(1turn);
	}
}
</style>

<script>
export default {
	name: "Loading",
	props: ["type"],

	data() {
		return {};
	},
	created() {},
	mounted() {
		let el = this.$refs.icon;
		if (el) {
			let color = getComputedStyle(el).color;
			el.style["border-right-color"] = color;
			el.style["border-top-color"] = color;
		}
	},
	watch: {},

	render(h) {
		switch (this.type) {
			case "icon":
				return this.loadingIcon(h);
			case "header":
				return <div>Loading...&nbsp;{this.loadingIcon(h)}</div>;
			case "inline-header":
				return <span>Loading...&nbsp;{this.loadingIcon(h)}</span>;
			case "table":
				return <div class="text-center my-2 text-lg">Loading...&nbsp;{this.loadingIcon(h)}</div>;
			case "large":
				return this.loadingLarge(h);
			case "medium":
				return this.loadingMedium(h);
			case "page":
				return <div class="loading-page">{this.loadingIcon(h)}</div>;
			case "overlay":
				return <div class="loading-page overlay">{this.loadingIcon(h)}</div>;
		}

		return null;
	},
	methods: {
		loadingIcon() {
			return <div class="loading-icon" ref="icon" />;
			//return <i class="far fa-spinner-third fa-spin" />;
		},
		loadingMedium(h) {
			return <div class="loading-medium">{this.loadingIcon(h)}</div>;
		},
		loadingLarge(h) {
			return <div class="loading-large">{this.loadingIcon(h)}</div>;
		}
	}
};
</script>
